import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useFieldArray, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { FloatInput, FloatNumericInput } from "src/componentes";
import {
  CTeDto,
  CTeValoresPrestacaoDto,
  getLocal,
  STORAGECTE_KEY,
  updateLocal,
} from "../CTe.Dto";
import { ValoresFormType, ValoresSchema } from "./CTe.Cadastro.Dto";

const CTeCadastroValoresView = () => {
  const navigate = useNavigate();
  const cte = getLocal<CTeDto>(STORAGECTE_KEY);
  const valores = cte?.valoresPrestacao;

  const form = useForm<ValoresFormType>({
    resolver: yupResolver(ValoresSchema),
    defaultValues: {
      valorPrestacaoServico: valores?.valorPrestacaoServico ?? 0,
      valorReceber: valores?.valorReceber ?? 0,
      valorTotalTributos: valores?.valorTotalTributos ?? 0,
      componentes:
        valores?.componentes && valores.componentes.length > 0
          ? valores.componentes
          : [
              {
                nome: "FRETE VALOR",
                valor: 0,
              },
            ],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: "componentes",
  });

  const handleVoltar = () => {
    navigate("../carga");
  };

  const onSubmit = (data: ValoresFormType) => {
    const valoresDto: CTeValoresPrestacaoDto = {
      valorPrestacaoServico: Number(data.valorPrestacaoServico),
      valorReceber: Number(data.valorReceber),
      valorTotalTributos: Number(data.valorTotalTributos),
      componentes: (data.componentes || []).map((c) => ({
        nome: c.nome,
        valor: Number(c.valor),
      })),
    };

    updateLocal<CTeDto>(STORAGECTE_KEY, {
      valoresPrestacao: valoresDto,
    });

    navigate("../documentos");
  };

  return (
    <Form noValidate onSubmit={form.handleSubmit(onSubmit)} className="mt-3 mb-5">
      <h5 className="mb-3 text-primary">Valores da Prestação do Serviço</h5>
      <Row className="g-3">
        <Col xs={12} md={4}>
          <FloatNumericInput
            label="Valor da Prestação do Serviço"
            control={form.control}
            name="valorPrestacaoServico"
            errorsMessage={form.formState.errors.valorPrestacaoServico}
          />
        </Col>
        <Col xs={12} md={4}>
          <FloatNumericInput
            label="Valor a Receber"
            control={form.control}
            name="valorReceber"
            errorsMessage={form.formState.errors.valorReceber}
          />
        </Col>
        <Col xs={12} md={4}>
          <FloatNumericInput
            label="Total Tributos"
            control={form.control}
            name="valorTotalTributos"
            errorsMessage={form.formState.errors.valorTotalTributos}
          />
        </Col>
      </Row>

      <div className="d-flex justify-content-between align-items-center mt-4 mb-3">
        <h5 className="text-primary mb-0">Componentes da Prestação</h5>
        <Button
          variant="outline-primary"
          size="sm"
          onClick={() =>
            append({
              nome: "",
              valor: 0,
            })
          }
        >
          + Adicionar Componente
        </Button>
      </div>

      {fields.map((field, index) => (
        <div key={field.id} className="mb-4">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <strong>Componente #{index + 1}</strong>
            {fields.length > 1 && (
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => remove(index)}
              >
                Remover
              </Button>
            )}
          </div>
          <Row className="g-3">
            <Col xs={12} md={6}>
              <FloatInput
                label="Nome do Componente"
                registerField={form.register(`componentes.${index}.nome`)}
                errorsMessage={form.formState.errors.componentes?.[index]?.nome}
                inputMask="maiusculas"
              />
            </Col>
            <Col xs={12} md={6}>
              <FloatNumericInput
                label="Valor do Componente"
                control={form.control}
                name={`componentes.${index}.valor`}
                errorsMessage={form.formState.errors.componentes?.[index]?.valor}
              />
            </Col>
          </Row>
        </div>
      ))}

      <div className="fixed-bottom">
        <Container className="py-3">
          <Row>
            <Col xs={6} className="d-grid">
              <Button variant="outline-secondary" onClick={handleVoltar}>
                Voltar
              </Button>
            </Col>
            <Col xs={6} className="d-grid">
              <Button variant="outline-primary" type="submit">
                Próximo
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </Form>
  );
};

export default CTeCadastroValoresView;
